import { isEmpty } from 'ramda';
import replaceAll from '../common/replaceAll';
const ADDRESS_PATTERNS = {
    TITLE: '{title}',
    FIRST_NAME: '{firstName}',
    MIDDLE_NAME: '{middleName}',
    LAST_NAME: '{lastName}',
    ALTERNATIVE_FIRST_NAME: '{alternativeFirstName}',
    ALTERNATIVE_LAST_NAME: '{alternativeLastName}',
    LINE1: '{line1}',
    LINE2: '{line2}',
    PROVINCE: '{province}',
    POSTAL_CODE: '{postalCode}',
    TOWN: '{town}',
    COUNTRY: '{country}',
    DISTRICT: '{district}',
    BUILDING: '{building}',
    CARE_OF: '{careOf}',
    PREFECTURE: '{prefecture}',
    PREFIX: '{prefix}',
    CELL_PHONE: '{cellPhone}',
    NEW_LINE: '[newLine]',
};
const DEFAULT_ADDRESS_FORMAT = `${ADDRESS_PATTERNS.LINE1}${ADDRESS_PATTERNS.NEW_LINE}${ADDRESS_PATTERNS.LINE2}${ADDRESS_PATTERNS.NEW_LINE}${ADDRESS_PATTERNS.POSTAL_CODE} ${ADDRESS_PATTERNS.TOWN}`;
const formatAddress = (getFormatters) => (address, pattern = 'fullAddress') => {
    const isAddressEmpty = isEmpty(address) || JSON.stringify(address) === '{}';
    if (!address || isAddressEmpty) {
        return null;
    }
    // Currently the only provided formatting pattern is fullAddress
    const formattingPatterns = getFormatters();
    const addressPatterns = formattingPatterns.addressFormatter;
    const addressFormat = (addressPatterns && addressPatterns[pattern]) || DEFAULT_ADDRESS_FORMAT;
    const getAddressCountryName = () => {
        const { country } = address;
        if (!country) {
            return '';
        }
        if (typeof country === 'string') {
            return country;
        }
        return country.name;
    };
    return replaceAll(addressFormat.replace(new RegExp('\\[newLine\\]', 'g'), '\n'), {
        [ADDRESS_PATTERNS.TITLE]: address.title || '',
        [ADDRESS_PATTERNS.FIRST_NAME]: address.firstName || '',
        [ADDRESS_PATTERNS.MIDDLE_NAME]: address.middleName || '',
        [ADDRESS_PATTERNS.LAST_NAME]: address.lastName || '',
        [ADDRESS_PATTERNS.ALTERNATIVE_FIRST_NAME]: address.alternativeFirstName || '',
        [ADDRESS_PATTERNS.ALTERNATIVE_LAST_NAME]: address.alternativeLastName || '',
        [ADDRESS_PATTERNS.LINE1]: address.line1 || '',
        [ADDRESS_PATTERNS.LINE2]: address.line2 || '',
        [ADDRESS_PATTERNS.PROVINCE]: address.adprovince || address.ADProvince || address.province || '',
        [ADDRESS_PATTERNS.TOWN]: address.town || '',
        [ADDRESS_PATTERNS.POSTAL_CODE]: address.postalCode || '',
        [ADDRESS_PATTERNS.COUNTRY]: getAddressCountryName(),
        [ADDRESS_PATTERNS.DISTRICT]: address.district || '',
        [ADDRESS_PATTERNS.BUILDING]: address.building || '',
        [ADDRESS_PATTERNS.CARE_OF]: address.careOf || '',
        [ADDRESS_PATTERNS.PREFECTURE]: address.prefecture || '',
        [ADDRESS_PATTERNS.PREFIX]: address.prefix || '',
        [ADDRESS_PATTERNS.CELL_PHONE]: address.cellPhone || '',
    })
        .replace(/\n\s*\n/g, '\n')
        .trim();
};
export default formatAddress;
//# sourceMappingURL=formatAddress.js.map